import { msg } from '@gonfalon/messages/msg';
import type { SearchFieldProps } from '@launchpad-ui/components';
import { Group, IconButton, Input, ProgressBar, SearchField } from '@launchpad-ui/components';
import { Icon } from '@launchpad-ui/icons';

import styles from './TagSearchField.module.css';

interface TagSearchFieldProps extends SearchFieldProps {
  isPending: boolean;
}

export function TagSearchField({ isPending, ...props }: TagSearchFieldProps) {
  return (
    <SearchField {...props} aria-label={msg('ui.tagPicker.searchLabel')} autoFocus>
      <Group>
        <Icon name="search" size="small" />
        <Input placeholder={msg('ui.tagPicker.searchLabel')} />
        {isPending && (
          <span className={styles.progressBar}>
            <ProgressBar aria-label={msg('ui.status.loading')} isIndeterminate size="small" />
          </span>
        )}
        <IconButton aria-label="clear" icon="cancel-circle-outline" size="small" variant="minimal" />
      </Group>
    </SearchField>
  );
}
